// Quick Add Module
// This module handles quick view modal functionality
// Trigger with custom event: 'open_quick_view'
// Event detail: { productHandle, productId, position, addToCartLocation }

let opend_pop;

// Global callback functions for JSONP requests if needed
window.shopperActivityCallback = window.shopperActivityCallback || function(data) {
    // Handle shopper activity response if needed
};

window.upsellCallback = window.upsellCallback || function(data) {
    // Handle upsell callback response if needed
};

// Helper function to add accessibility attributes to slider dots
function addDotsAttr() {
    if (typeof $ !== 'undefined') {
        $('.quick-view-images .slick-dots li').each(function(i, ele) {
            $(ele).find('button').attr('aria-label', 'Go to slide ' + (i+1));
            if ($(ele).hasClass('slick-active')) {
                $(ele).find('button').attr('aria-current', true);
            } else {
                $(ele).find('button').removeAttr('aria-current');
            }
        });
    }
}

class QuickAddManager {
    constructor() {
        this.sliderSettings = {
            arrows: false,
            dots: true,
            infinite: true,
            initialSlide: 0,
            slidesToScroll: 1,
            slidesToShow: 1,
            cssEase: 'linear',
            swipe: true,
            mobileFirst: true,
        };
        
        // Listen for custom event
        document.addEventListener('open_quick_view', (evt) => {
            console.log('open_quick_view', evt.detail);
            this.handleQuickView(evt.detail);
        });
    }
    
    async handleQuickView(detail) {
        const { productHandle, productId, position, addToCartLocation = 'Quick View', isSecondaryLanguage = false } = detail;
        
        if (!productHandle) {
            console.warn('Quick view requires productHandle');
            return;
        }
        
        // Set location override for analytics
        window.addToCartLocationOverride = addToCartLocation;

        // Determine locale prefix using Liquid
        
        
        const localePrefix = '';
        
        try {
            const response = await fetch(`${localePrefix}${productHandle}?view=quick_view`);
            const addToCartLocationFinal = window.addToCartLocationOverride || 'Quick View';
            
            // Ensure the quick view modal exists
            let quickViewModal = document.querySelector('.product_quickview');
            if (!quickViewModal) {
                // Create the modal if it doesn't exist
                document.body.insertAdjacentHTML('beforeend', `
                    <div class="product_quickview" data-add-to-cart-location="${addToCartLocationFinal}"></div>
                    <div class="overlay"></div>
                `);
                quickViewModal = document.querySelector('.product_quickview');
            }

            quickViewModal.setAttribute('data-add-to-cart-location', addToCartLocationFinal);
            
            const data = await response.text();
            
            quickViewModal.innerHTML = data;
            
            // Extract the product data from the script tag with class="quick"
            const quickScriptMatch = data.match(/<script[^>]*class="quick"[^>]*>(.*?)<\/script>/s);
            const getProductData = quickScriptMatch ? JSON.parse(quickScriptMatch[1].trim()) : {};
            window.productVariants = getProductData?.variants || [];
            console.log('[Quick View] Product data extracted:', getProductData.title);
            
            // CRITICAL: Execute inline scripts manually since innerHTML doesn't auto-execute them
            // This is needed for variant selectors (Shopify.OptionSelectors) to work
            const scriptRegex = /<script\b(?![^>]*type=["']application\/json["'])[^>]*>([\s\S]*?)<\/script>/gi;
            const scripts = [...data.matchAll(scriptRegex)];
            
            console.log(`[Quick View] Found ${scripts.length} executable scripts to process`);
            
            // Execute scripts in order, ensuring each one completes before the next
            scripts.forEach((match, index) => {
                const scriptContent = match[1].trim();
                if (scriptContent) {
                    try {
                        // Check if this is a script tag with src attribute (external script)
                        const srcMatch = match[0].match(/src=["']([^"']+)["']/);
                        
                        if (srcMatch) {
                            // External script - create script tag with src
                            const scriptEl = document.createElement('script');
                            scriptEl.src = srcMatch[1];
                            scriptEl.async = match[0].includes('async');
                            scriptEl.defer = match[0].includes('defer');
                            document.head.appendChild(scriptEl);
                            console.log(`[Quick View] Loaded external script: ${srcMatch[1]}`);
                        } else {
                            // Inline script - execute directly
                            const scriptEl = document.createElement('script');
                            scriptEl.textContent = scriptContent;
                            document.body.appendChild(scriptEl);
                            console.log(`[Quick View] Executed inline script ${index + 1}`);
                            // Clean up after execution
                            setTimeout(() => scriptEl.remove(), 100);
                        }
                    } catch (e) {
                        console.error(`[Quick View] Error executing script ${index + 1}:`, e);
                    }
                }
            });

            // Ensure Shopify.resizeImage is available (needed before custom colors load)
            if (typeof Shopify === 'undefined') {
                window.Shopify = {};
            }
            if (typeof Shopify.resizeImage !== 'function') {
                Shopify.resizeImage = function(src, size) {
                    try {
                        if (size === 'original') return src;
                        var match = src.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
                        return match[1] + '_' + size + '.' + match[2];
                    } catch(e) {
                        return src;
                    }
                };
            }

            // Wait a brief moment for scripts to initialize before continuing
            // This ensures Shopify.OptionSelectors is properly initialized
            setTimeout(() => {
                this.initializeQuickViewComponents(quickViewModal, getProductData);
            }, 50);

        } catch (error) {
            console.error('Error fetching product data:', error);
        }
    }
    
    initializeQuickViewComponents(quickViewModal, getProductData) {
        // Handle custom colors - replicates the inline scripts in the template
        // Each color element has class like "pro_{handle}" and needs to be shown after fetching product data
        if (typeof $ !== 'undefined') {
            const $modal = $(quickViewModal);
            
            // Find all color elements within the modal
            $modal.find('.color_element.custom').each(function() {
                const colorElement = $(this);
                const classes = colorElement.attr('class');
                
                // Extract the product handle from the class (e.g., "pro_possession-black" -> "possession-black")
                const proClassMatch = classes.match(/pro_([^\s]+)/);
                if (!proClassMatch) return;
                
                const pro = proClassMatch[1];
                const proClass = '.pro_' + pro;
                
                // Fetch product data and show the color swatch (mimics inline script exactly)
                $.getJSON('/products/' + pro + '.js', function(proData) {
                    console.log(`[Color Debug] Product: ${pro}`, {
                        title: proData.title,
                        featured_image: proData.featured_image
                    });
                    
                    var vimg = Shopify.resizeImage(proData.featured_image, '100x');
                    var $label = $modal.find(proClass + ' label');
                    $label.css('background-image', 'url(' + vimg + ')');
                    $modal.find(proClass).attr({'title': proData.title, 'data-idx': window.image_Ct});
                    $modal.find(proClass).addClass('show_swatch show').addClass('swatch-visible').show();
                    window.image_Ct = (window.image_Ct || 0) + 1;
                }).fail(function(jqXHR, textStatus, errorThrown) { 
                    console.log(`[Color Debug] Failed to load product: ${pro}`, textStatus, errorThrown);
                    $modal.find(proClass).remove().removeClass('hide_swatch');
                });
            });
        }

        // Show the modal
        quickViewModal.classList.add('active');
        document.querySelector('.overlay')?.classList.add('active');
        document.body.classList.add('Fixed');

        // Initialize slick slider if available
        if (typeof $ !== 'undefined' && $.fn.slick) {
            const carousel = quickViewModal.querySelector('#quick-view-carousel');
            if (carousel) {
                // Destroy existing slider if present
                const $carousel = $(carousel);
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
                $carousel.slick(this.sliderSettings);
                addDotsAttr();
            }
        }

        // Focus management
        setTimeout(() => {
            const mainQuick = quickViewModal.querySelector('.main-quick');
            if (mainQuick) {
                mainQuick.focus();
            }
        }, 100);

        // Analytics tracking
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'quick_view_open',
                quickviewProduct: getProductData,
                _clear: true,
            });

            setTimeout(() => {
                const variant = document.querySelector(`.product_quickview.active button.swym-button[data-product-id="${getProductData.id}"]`);
                const variantID = variant?.getAttribute('data-variant-id');

                window.dataLayer.push({
                    event: 'quick_view_variant',
                    variant_id: variantID,
                    _clear: true,
                });
            }, 100);
        }
    }
}

// Initialize the quick add manager when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        const quickAddManager = new QuickAddManager();
        console.log('QuickAddManager initialized');
    });
} else {
    // DOM already loaded
    const quickAddManager = new QuickAddManager();
    console.log('QuickAddManager initialized');
}

// Expose globally for non-module usage
window.QuickAddManager = window.QuickAddManager || QuickAddManager;
